// @flow
import React from 'react';
import styles from './TopApplicantBadge.less';
import Medal from './Medal';
import NavLink from 'src/components/NavLink/NavLink';
import { tabImpression } from 'src/store/fitme/fitme';
import { connect } from 'react-redux';

import ScrollMonitor from 'react-scrollmonitor';
import { ReadMore, Text, TextLink, Section } from 'seek-style-guide/react';

type Props = {
  tabImpression: Function
};

const mapDispatchToProps = {
  tabImpression
};

const TopApplicantBadge = ({ tabImpression: trackTabImpression }: Props) => (
  <ScrollMonitor enterViewport={trackTabImpression}>
    <div data-automation="top-applicant-badge">
      <div className={styles.spacer} />
      <Section className={styles.root}>
        <Medal className={styles.icon} />
        <div>
          <Text strong>You may be a strong applicant.</Text>
          <ReadMore moreLabel="Show more" lessLabel="Show less">
            <Text>
              {'Using data based on employers’ past behaviour, the '}
              <NavLink
                analytics="top-applicant-badge-default-resume-link-clicked"
                location="/profile/me/resume"
                component={TextLink}
              >
                default resumé
              </NavLink>
              {
                ' in your profile and other factors, SEEK predicts you may be a strong applicant for this role.'
              }
            </Text>
          </ReadMore>
        </div>
      </Section>
    </div>
  </ScrollMonitor>
);

export default connect(
  null,
  mapDispatchToProps
)(TopApplicantBadge);
